import { Input, useMask } from '@yes.technology/react-toolkit'

const cssClassToStatusClass = {
  'is-valid': 'valid',
  'is-invalid': 'error',
  '': 'default'
}

function ActivityInputInteger({
  id,
  value,
  informational,
  required,
  onChange,
  cssClass,
  label,
  helpText,
  explanationText,
  formatMask,
  disabled
}) {
  const removeNonIntegerCharacters = (value) => {
    const regex = /[^0-9]+/g
    const replacedValue = value.replace(regex, '')

    return replacedValue
  }

  const { applyMask } = useMask()

  const handleValue = (value) => {
    const integerValue = removeNonIntegerCharacters(value)
    const formattedValue = formatMask
      ? applyMask(integerValue, formatMask)
      : integerValue

    onChange(formattedValue)
  }

  return (
    <Input
      id={id}
      required={required}
      informational={informational}
      value={value}
      onChange={handleValue}
      label={label}
      placeholder={helpText || explanationText}
      aria-label={label}
      heightClass='regular'
      statusClass={informational ? undefined : cssClassToStatusClass[cssClass]}
      disabled={disabled}
    />
  )
}

export default ActivityInputInteger
